import { useMutation } from '@apollo/client';

import { UpdateClientContactInput } from '__generated__/GQL';

import { ClientContactForm } from '../../components/FormModal/hooks/useClientFormModalContext';
import { refetchGetClient } from '../useGetClient';
import { trimClientContactNames } from '../utils';
import { UpdateClientContactDocument } from './graphql/updateClientContact.gql';

export const useUpdateClientContact = (clientId: string) => {
  const [mutation, result] = useMutation(UpdateClientContactDocument, {
    awaitRefetchQueries: true,
    refetchQueries: [refetchGetClient(clientId)],
  });

  const updateClientContact = (clientContact: ClientContactForm) => {
    // Explicitly pick properties to make sure we don't send
    // unnecessary fields such as `__typename` to the server.
    const { clientContactId, email, firstName, lastName, phone } =
      clientContact;

    const input: UpdateClientContactInput = {
      ...trimClientContactNames({
        clientContactId,
        email,
        firstName,
        lastName,
        phone,
      }),
      clientId,
    };
    return mutation({ variables: { input } });
  };

  return { updateClientContact, ...result };
};
